import { render, staticRenderFns } from "./NotificationContentPurchase.vue?vue&type=template&id=babd4944&scoped=true&"
import script from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContentPurchase.vue?vue&type=style&index=0&id=babd4944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babd4944",
  null
  
)

export default component.exports